<template>
    <!-- 底部栏 -->
    <section class="footer">
        <div class="content w-1200">
            <div class="content-cont">
                <div class="footer-left">
                    <div class="footer-ul-block clearfix">
                        <ul class="ul1">
                            <div>
                                <span class="footer-span">解决方案</span>
                                <li @click="$router.push('/phoneSolution')"><a href="javascript:;" class="footer-ul-li-a">手机行业</a></li>
                                <li @click="$router.push('/petSolution')"><a href="javascript:;" class="footer-ul-li-a">宠物行业</a></li>
                                <li @click="$router.push('/householdSolution')"><a href="javascript:;" class="footer-ul-li-a">家电行业</a></li>
                            </div>
                        </ul>
                        <ul class="ul2">
                            <span class="footer-span">走进中保</span>
                            <li @click="pageJump('aboutUs')"><a href="javascript:;" class="footer-ul-li-a">关于中保</a></li>
                            <li @click="pageJump('news')"><a href="javascript:;" class="footer-ul-li-a">新闻资讯</a></li>
                            <li @click="pageJump('joinUs')"><a href="javascript:;" class="footer-ul-li-a">招聘信息</a></li>
                        </ul>
                        <ul class="ul3">
                            <span class="footer-span">联系方式</span>
                            <li><i class="icon el-icon-phone-outline"></i>联系客服  &nbsp;4000-399-666 / 13530955386</li>
                            <li><i class="icon el-icon-message"></i>商务邮箱  &nbsp;bd@zhongbaojinfu.com.cn</li>
                            <li><i class="icon el-icon-location-outline"></i>联系地址  &nbsp;深圳市前海深港合作区南山街道桂湾三路186号华强金融大厦1802-1805</li>
                        </ul>
                    </div>
                </div>
                <div class="footer-right">
                    <div class="mb10">关注我们</div>
                    <!-- <div class="tel">4000-399-666</div> -->
                    <div><img src="../assets/ewm.png" alt="" style="width:100px;margin-top:20px"><img src="../assets/ewm2.png" alt="" style="width:100px;margin-left:20px"></div>
                </div>
            </div>
        </div>
        <div class="copyright">
            <p class="cp-content">Copyright©2025 中保金服（深圳）科技有限公司 版权所有</p>
            <div v-if="gonganNumber" class="filing-box">
              <img src="@/assets/public-security.png" style="margin-right: 5px;" width="14px" alt="">
              <a :href="gonganUrl" rel="noreferrer" target="_blank">{{ gonganNumber }}</a>
            </div>
            <a v-if="icpNumber" :href="icpUrl" target="_blank">{{ icpNumber }}</a>
        </div>
    </section>
</template>

<script>
export default {
  props: {
    isSelf: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      // ICP 备案文案与跳转地址，来自 .env
      icpNumber: process.env.VUE_APP_ICP_NUMBER,
      icpUrl: process.env.VUE_APP_ICP_URL,
      // 公安网备案文案与查询编码
      gonganNumber: process.env.VUE_APP_GONGAN_NUMBER,
      gonganCode: process.env.VUE_APP_GONGAN_CODE
    }
  },
  computed: {
    // 公安部备案查询链接：编码变化时自动拼接
    gonganUrl () {
      return `https://beian.mps.gov.cn/#/query/webSearch?code=${this.gonganCode}`
    }
  },
  methods: {
    pageJump (id) {
      if (!this.isSelf) {
        localStorage.setItem('id', id)
        this.$router.push('/aboutUs')
      } else {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.footer{
    width: 100%;
    background: #151c29;
    height: 300px;
    padding-top: 62px;
    color: #c3cde6;
    position: relative;
    .content{
        margin: 0 auto;
        display: flex;
        .content-cont{
            width: 100%;
            display: flex;
        }
        .footer-left{
            flex: 1;
            ul{
                float: left;
                margin: 0 40px;
                .footer-span{
                    color: #c3cde6;
                    margin-bottom: 10px;
                    display: inline-block;
                }
                li{
                    padding: 15px 0;
                    display: block;
                    font-size: 14px;
                    color: #7a8399;
                    .icon{
                        vertical-align: bottom;
                        font-size: 18px;
                        margin-right: 5px;
                    }
                    a{
                        cursor: pointer;
                        color: #7a8399;
                        &:hover{
                                color: #2284e7;
                        }
                    }
                }
            }
        }
        .footer-right{
            // width: 380px;
            display: inline-block;
            text-align: center;
            margin-right:40px;
            .tel{
                color: #007dff;
                font-size: 24px;
                margin-top: 10px;
            }
        }
    }
    .copyright {
        width: 100%;
        margin-top: 38px;
        margin-bottom: 20px;
        font-size: 12px;
        line-height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: .5;
        .cp-content {
          margin-right: 10px;
        }
        a{
            color: #c3cde6;
        }

        .filing-box {
          display: flex;
          align-items: center;
          margin-right: 5px;
        }
    }
}
</style>
